import { useContext, useMemo } from 'react';
import { getFilteredItems } from '../../../Utils/items';
import { bookingState } from '../client-state/booking-state-context';
import Items from '../../../ui-components/Items';
import useBookingShop from '../server-data/use-booking-shop';
import { View } from '../../../Utils/graphql-sdk';

const ItemsWithData = () => {
  const { data: shop } = useBookingShop();
  const { state } = useContext(bookingState);

  const filteredItems = useMemo(() => {
    return getFilteredItems({
      items: shop?.items || [],
      bookingDate: state.booking.date,
      timezone: shop?.timezoneName,
      category: state.selectedItemCategory,
      pageType: View.Prebook,
      duration: state.booking.duration,
    });
  }, [
    shop?.items,
    state.booking.date,
    shop?.timezoneName,
    state.selectedItemCategory,
    state.booking.duration,
  ]);

  return (
    <Items
      items={filteredItems}
      currentCategory={state.selectedItemCategory}
      itemsPerPage={shop?.shopSettings?.booking.itemsPerPage}
    />
  );
};

export default ItemsWithData;
